import * as React from "react"
import type { SVGProps } from "react"
const SvgAdmin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 13.14q-1.47 0-2.49-1.01A3.4 3.4 0 0 1 8.5 9.64q0-1.47 1.01-2.48A3.4 3.4 0 0 1 12 6.14q1.47 0 2.49 1.02c1.02 1.02 1.01 1.5 1.01 2.48q0 1.48-1.01 2.49A3.4 3.4 0 0 1 12 13.14m0-2a1.46 1.46 0 0 0 1.5-1.5 1.46 1.46 0 0 0-1.5-1.5 1.45 1.45 0 0 0-1.5 1.5 1.46 1.46 0 0 0 1.5 1.5m0-6.87L6 6.52v4.72q0 1.35.38 2.63t1.02 2.4q1.05-.53 2.2-.83a10 10 0 0 1 2.4-.3q1.25 0 2.4.3t2.2.83q.65-1.13 1.02-2.4.38-1.28.38-2.63V6.52zm0 12.87q-.9 0-1.75.2a9 9 0 0 0-1.62.55q.72.76 1.57 1.3.86.55 1.8.85a7 7 0 0 0 1.8-.85 9 9 0 0 0 1.58-1.3 9 9 0 0 0-1.63-.55 8 8 0 0 0-1.75-.2m0 4.9a2 2 0 0 1-.62-.1A10 10 0 0 1 6 17.78q-2-3.04-2-6.54V6.52q0-.63.36-1.13.37-.5.94-.72l6-2.25a2 2 0 0 1 .7-.13q.35 0 .7.13l6 2.25q.57.23.94.72.36.5.36 1.13v4.72q0 3.5-2 6.54a10 10 0 0 1-5.38 4.16 2 2 0 0 1-.62.1" />
  </svg>
)
export default SvgAdmin
